import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

interface FuelReceipt {
    id: number;
    gasStation?: string;
    totalAmount: number;
    liters: number;
    refuelDate: string;
    vehicleLicensePlate: string;
}

interface LinkFuelModalProps {
    isOpen: boolean;
    onClose: () => void;
    availableRecords: FuelReceipt[];
    onLink: (id: number) => void;
}

const LinkFuelModal: React.FC<LinkFuelModalProps> = ({
    isOpen,
    onClose,
    availableRecords,
    onLink
}) => {
    const { t } = useLanguage();

    if (!isOpen) return null;

    return (
        <div className="modal show d-block" tabIndex={-1} style={{ background: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{t('link.fuel.receipt')}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {availableRecords.length === 0 ? (
                            <p>{t('no.unlinked.fuel.receipts')}</p>
                        ) : (
                            <div>
                                <p>{t('select.fuel.receipt.to.link')}:</p>
                                {availableRecords.map(fuel => (
                                    <div key={fuel.id} className="border rounded p-2 mb-2 d-flex align-items-center justify-content-between">
                                        <div>
                                            <strong>{fuel.gasStation || t('unknown.station')}</strong><br />
                                            <small>{t('total.amount')}: ${fuel.totalAmount} | {t('liters')}: {fuel.liters}L</small><br />
                                            <small>{t('date')}: {new Date(fuel.refuelDate).toLocaleDateString()} | {t('vehicle')}: {fuel.vehicleLicensePlate}</small>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm ms-2"
                                            onClick={() => onLink(fuel.id)}
                                        >
                                            {t('link')}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>{t('cancel')}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LinkFuelModal;
